var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order.customer !== null
    ? _c("address", [
        _vm.order.customer.firstName && _vm.order.customer.lastName
          ? _c("span", [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.order.customer.firstName) +
                  " " +
                  _vm._s(_vm.order.customer.lastName) +
                  ","
              ),
              _c("br"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.customer.address.houseNameNumber
          ? _c("span", [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.order.customer.address.houseNameNumber) +
                  ","
              ),
              _c("br"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.customer.address.addressLine1
          ? _c("span", [
              _vm._v(
                "\n    " + _vm._s(_vm.order.customer.address.addressLine1) + ","
              ),
              _c("br"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.customer.address.addressLine2
          ? _c("span", [
              _vm._v(
                "\n    " + _vm._s(_vm.order.customer.address.addressLine2) + ","
              ),
              _c("br"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.customer.address.townCity
          ? _c("span", [
              _vm._v(
                "\n    " + _vm._s(_vm.order.customer.address.townCity) + ","
              ),
              _c("br"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.customer.address.postcodeZip
          ? _c("span", [
              _vm._v("\n  " + _vm._s(_vm.order.customer.address.postcodeZip)),
              _c("br"),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }